import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { EmployeesTable } from "../../UI/Employees/EmployeesTable";

const EmployeesPanel = () => {
  return (
    <div>
      <PanelHead title="Employees" />
      <PanelBody content={<EmployeesTable />} />
    </div>
  );
};

export default React.memo(EmployeesPanel);
